import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginDetails } from '../../parents-login/parents-login/parents-login.component';
import { DialogMessageTypes, MessageDialogComponent } from '../../../common/message-dialog/message-dialog.component';
import { ProcessingDialogComponent } from '../../../common/processing-dialog/processing-dialog.component';
import { ParentsPortalControllerService } from '../../../../services/parents-portal/parents-portal-controller-service';
import { ResponseObject } from '../../../../models/response-object';
import { ResponseStatus } from '../../../enums/response-statuses';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  loginDetails: LoginDetails= new LoginDetails();
  @ViewChild(MessageDialogComponent) messageDialog: MessageDialogComponent;
  @ViewChild(ProcessingDialogComponent) processingDialog: ProcessingDialogComponent;
  
  constructor( private parentPortalControllerService: ParentsPortalControllerService) { }

  ngOnInit(): void {
    this.loginDetails= new LoginDetails();
  }

  reset(){
    if (this.loginDetails.Username == "" || this.loginDetails.Username == undefined) {
      this.messageDialog.show("Provide your mobile number.", DialogMessageTypes.Information);
    }
    else {
      this.processingDialog.show();
      sessionStorage.setItem("token","");
      this.parentPortalControllerService.utilitiesGet("ParentsPortalUsers/ResetPassword?username=" + this.loginDetails.Username).subscribe(
        data => {
          this.processingDialog.hide();
          let response: ResponseObject = data;
          if (response.Status == ResponseStatus.Success) {
            this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
          }
          else if (response.Status == ResponseStatus.Failure) {
            this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
          }
          else {
            this.messageDialog.show("A system error was encountered processing your request, try again later.", DialogMessageTypes.SystemError);
          }
        },
        error => {
          this.processingDialog.hide();
          this.messageDialog.show("A system error was encountered processing your request, try again later.", DialogMessageTypes.SystemError);
        }
      )     
    }
  }
}
